// PrimeNG's DynamicDialog: 'header' config doesn't accept HTML, so this is a workaround to add an icon to it.
export const addIconToModalHeader = (headerIconImagePath?: string) => {
  setTimeout(() => {
    const dialogHeaderElement = document?.getElementsByClassName('p-dialog-title')[0];

    if (dialogHeaderElement) {
      const image = new Image();
      image.src = headerIconImagePath;
      image.className = 'modal-header-icon';

      const imageContainer = document.createElement('span');
      imageContainer.className = 'modal-header-icon-container';
      imageContainer.appendChild(image);
      dialogHeaderElement.prepend(imageContainer);
    }
  }, 200);
};

export const addIconClassToModalHeader = (iconClass?: string) => {
  setTimeout(() => {
    const dialogHeaderElement = document?.getElementsByClassName('p-dialog-title')[0];

    if (dialogHeaderElement) {
      const iconContainer = document.createElement('i');
      iconContainer.className = `${iconClass} modal-header-icon pe-2 fs-5`;
      dialogHeaderElement.prepend(iconContainer);
    }
  }, 200);
};
